import React from 'react';
import { Link } from 'react-router-dom';

const Navbar = () => (
  <nav className='navbar navbar-expand-lg navbar-dark bg-primary'>
    <Link className='navbar-brand' to='/'>
      React Hooks Examples
    </Link>
    <button
      className='navbar-toggler'
      type='button'
      data-toggle='collapse'
      data-target='#navbarNav'
      aria-controls='navbarNav'
      aria-expanded='false'
      aria-label='Toggle navigation'
    >
      <span className='navbar-toggler-icon' />
    </button>
    <div className='collapse navbar-collapse' id='navbarNav'>
      <ul className='navbar-nav ml-auto'>
        <li className='nav-item'>
          <Link className='nav-link' to='/state'>
            useState
          </Link>
        </li>
        <li className='nav-item'>
          <Link className='nav-link' to='/effect'>
            useEffect
          </Link>
        </li>
      </ul>
    </div>
  </nav>
);

export default Navbar;
